// const wxMenu = {
//   appPath: '/upms',
//   children: [
//     {
//       appPath: '/upms',
//       key: 'app',
//       name: '应用管理',
//       nid: '1730505815229005826',
//       path: '/weixin/app',
//       pid: '1730480038409159233',
//       sortNumber: 1,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     // {
//     //   appPath: '/upms',
//     //   key: 'weixinUser',
//     //   name: '微信用户列表',
//     //   nid: '1730506126584774657',
//     //   path: '/weixin/user',
//     //   pid: '1730480038409159233',
//     //   sortNumber: 2,
//     //   sysVisibleFlag: true,
//     //   type: 'menu',
//     // },
//     // {
//     //   appPath: '/upms',
//     //   key: 'userLoginLog',
//     //   name: '登录记录',
//     //   nid: '1730506684741779457',
//     //   path: '/weixin/userLoginLog',
//     //   pid: '1730480038409159233',
//     //   sortNumber: 3,
//     //   sysVisibleFlag: true,
//     //   type: 'menu',
//     // },
//     {
//       appPath: '/upms',
//       key: 'validationFile',
//       name: '微信验证文件',
//       nid: '1730506818410053633',
//       path: '/weixin/validationFile',
//       pid: '1730480038409159233',
//       sortNumber: 4,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//   ],
//   key: 'WeChatManageConfig',
//   name: '微信管理配置',
//   nid: '1730480038409159233',
//   pid: 'A1730461264613687298',
//   sortNumber: 6,
//   sysVisibleFlag: true,
//   type: 'menu',
// }

// const messageMenu = {
//   appPath: '/upms',
//   children: [
//     {
//       appPath: '/upms',
//       key: 'template',
//       name: '模板列表',
//       nid: '1730504436653555714',
//       path: '/notify/template',
//       pid: '1730479907202941506',
//       sortNumber: 1,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     {
//       appPath: '/upms',
//       key: 'account',
//       name: '账号管理',
//       nid: '1730504558372257793',
//       path: '/notify/account',
//       pid: '1730479907202941506',
//       sortNumber: 2,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     {
//       appPath: '/upms',
//       key: 'notifyLog',
//       name: '通知日志',
//       nid: '1730504836597219329',
//       path: '/notify/logs',
//       pid: '1730479907202941506',
//       sortNumber: 3,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     {
//       appPath: '/upms',
//       key: 'configCenterUpMessage',
//       name: '上行消息',
//       nid: '1730505045817491457',
//       path: '/notify/upMessage',
//       pid: '1730479907202941506',
//       sortNumber: 4,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     {
//       appPath: '/upms',
//       key: 'configCenterUpMessageSubscribeConfig',
//       name: '上行消息订阅',
//       nid: '1730505249836826626',
//       path: '/notify/upMessageSubscribeConfig',
//       pid: '1730479907202941506',
//       sortNumber: 5,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//     // {
//     //   appPath: '/upms',
//     //   key: 'platform',
//     //   name: '平台管理',
//     //   nid: '1730505374382489601',
//     //   path: '/notify/platform',
//     //   pid: '1730479907202941506',
//     //   sortNumber: 6,
//     //   sysVisibleFlag: true,
//     //   type: 'menu',
//     // },
//     {
//       appPath: '/upms',
//       key: 'trendStatistics',
//       name: '通知统计',
//       nid: '1730505536337149954',
//       path: '/notify/trendStatistics',
//       pid: '1730479907202941506',
//       sortNumber: 7,
//       sysVisibleFlag: true,
//       type: 'menu',
//     },
//   ],
//   key: 'MessageManage',
//   name: '消息管理',
//   nid: '1730479907202941506',
//   pid: 'A1730461264613687298',
//   sortNumber: 5,
//   sysVisibleFlag: true,
//   type: 'menu',
// }

// const workOrderMenu = {
//   key: 'platform', //配置成子应用对应的name
//   name: '工单引擎',
//   path: '/workOrderEngine',
//   appPath: '/upms',
//   sortNumber: 22,
//   sysVisibleFlag: 1,
//   type: 'sys',
//   children: [
//     {
//       key: 'workOrderEngineManage',
//       name: '工单管理',
//       path: '/workOrderEngine/manage',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//     // {
//     //   key: 'notify',
//     //   name: '工单配置',
//     //   path: '',
//     //   appPath: '/upms',
//     //   sortNumber: 0,
//     //   sysVisibleFlag: 1,
//     //   type: 'menu',
//     //   level: 2,
//     //   // children: [],
//     // },
//     {
//       key: 'workOrderEngineTemplate',
//       name: '工单模板',
//       path: '/workOrderEngine/template',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//     {
//       key: 'workOrderEngineCustomField',
//       name: '自定义字段',
//       path: '/workOrderEngine/customField',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//     {
//       key: 'workOrderEnginePolicyCenter',
//       name: '策略中心',
//       path: '/workOrderEngine/policyCenter',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//   ],
//   level: 1,
// }

// const flowMenu = {
//   key: 'flow', //配置成子应用对应的name
//   name: '流程中心',
//   path: '/bpm',
//   appPath: '/upms',
//   sortNumber: 22,
//   sysVisibleFlag: 1,
//   type: 'sys',
//   children: [
//     {
//       key: 'bpmList',
//       name: '流程管理',
//       path: '/bpm/list',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//     {
//       key: 'bpmRecord',
//       name: '实例管理',
//       path: '/bpm/records',
//       appPath: '/upms',
//       sortNumber: 0,
//       sysVisibleFlag: 1,
//       type: 'menu',
//       level: 2,
//     },
//   ],
//   level: 1,
// }

export const caasLocalMenu = [
  // messageMenu,
  // workOrderMenu,
  // flowMenu,
  // wxMenu,
]
